import serverCall from "../serverCall";

const getAllUser = (page, limit, search) => {
  try {
    const response = serverCall.get(
      `/superAdmin/get-all-admin?page=${page}&limit=${limit}&search=${search}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getSingleAdmin = (userId) => {
  try {
    const response = serverCall.get(`/superAdmin/get-admin?userId=${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getProfile = () => {
  try {
    const response = serverCall.get(`/superAdmin/get-profile`);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteAdmin = (userId) => {
  try {
    const response = serverCall.delete(
      `/superAdmin/delete-admin?userId=${userId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createUser = (body) => {
  try {
    const response = serverCall.post(`/admin/create-user`, body);
    return response;
  } catch (error) {
    throw error;
  }
};
const changePassword = (oldPassword, currentPassword, type) => {
  try {
    const response = serverCall.patch(
      `/superAdmin/change-password`, {
      currentPassword: oldPassword,
      newPassword: currentPassword
    }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const updateAdmin = (body, userId) => {
  try {
    const response = serverCall.patch(
      `/superAdmin/update-admin?userId=${userId}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const updateProfile = (body) => {
  try {
    const response = serverCall.patch(`/users/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const AdminService = {
  createUser,
  getAllUser,
  getSingleAdmin,
  getProfile,
  deleteAdmin,
  updateAdmin,
  changePassword,
};

export default AdminService;
